/* eslint-disable no-restricted-imports */
import React from 'react';
import { Button as AntButton, type ButtonProps as AntButtonProps } from 'antd';
import clsx from 'clsx';

import classes from './button.module.scss';

export interface ButtonProps
  extends Omit<AntButtonProps, 'type' | 'ghost' | 'danger' | 'htmlType'> {
  type?:
    | 'default'
    | 'primary'
    | 'secondary'
    | 'danger'
    | 'text'
    | 'text-danger'
    | 'primary-link'
    | 'link'
    | 'icon';

  /**
   * Whether this button should have type="submit"
   */
  submit?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
  type = 'default',
  submit,
  ...props
}) => {
  return (
    <AntButton
      {...props}
      className={clsx(props.className, {
        // NOTE: we could use antd native createStyles but it requires additional dependency
        [classes.default]: type === 'default',
      })}
      type={
        (
          {
            secondary: 'default',
            icon: 'text',
            text: 'text',
            'text-danger': 'text',
            link: 'link',
          } as Record<string, AntButtonProps['type']>
        )[type] || 'primary'
      }
      ghost={['danger', 'default'].includes(type)}
      danger={['danger', 'text-danger'].includes(type)}
      htmlType={submit ? 'submit' : 'button'}
    />
  );
};
